// src/components/ui/Card.js
import React from "react";

export const Card = ({ children }) => (
  <div className="border rounded-lg p-4 shadow-md bg-white">{children}</div>
);

export const CardHeader = ({ children }) => (
  <div className="border-b pb-2 mb-2 font-semibold">{children}</div>
);

export const CardContent = ({ children }) => <div>{children}</div>;

export const CardTitle = ({ children }) => (
  <h2 className="text-lg font-bold">{children}</h2>
);
